import { render, staticRenderFns } from "./MultipleChoiceDataSetGuidelineSelect.vue?vue&type=template&id=9330129e&scoped=true&"
import script from "./MultipleChoiceDataSetGuidelineSelect.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceDataSetGuidelineSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9330129e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
